import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import backgroundImage from '../../assets/Images/Login_background_Image.gif';
import vizLogo from '../../assets/Images/Vizlink_logo.png';
import { Col, Container, Image, Modal, Row } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FormikControl from '../../layouts/Input/FormikControl';
import { VerifyUserForUpdatePassword , UpdateUserPasswordThroughEmail } from './ResetPasswordThroughEmailAction';
import { toast } from 'react-toastify';


const ResetPasswordThroughEmail = props =>
{
    const [currentScreen, setCurrentScreen] = useState('resetPassword');
    const [resetPasswordObject, setResetPasswordObject] = useState({email: '', newPassword: '', confirmPassword: '', userId: '', token: ''});

    useEffect(async()=>{
        const queryParams = new URLSearchParams(window.location.search);
        let updatePasswordToken = queryParams.get("updatePasswordToken");
        let result = await props.VerifyUserForUpdatePassword(updatePasswordToken);
        if(result.data.isSuccess)
        {
            setResetPasswordObject({...resetPasswordObject, email: result.data.response.email, userId: result.data.response.id, token : updatePasswordToken})
        }
        else
        {
            setCurrentScreen('invalidUpdateRequest');
        }
    },[])

    const resetPasswordValidationSchema = Yup.object().shape
    ({
        email: Yup.string()
                .required('Email is required'),
        newPassword: Yup.string()
            .required('Password is required')
            .min(8, 'Password must be at least 8 characters long')
            .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
            .matches(/[a-zA-Z0-9]/, 'Password must be alphanumeric')
            .matches(/[^a-zA-Z0-9]/, 'Password must contain at least one special character'), 
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
            .required('Confirm Password is required')           
    })

    const resetPasswordSubmit = async () => {
        var result = await props.UpdateUserPasswordThroughEmail(resetPasswordObject);
        if(result.data.response)
        {
            setCurrentScreen('passwordUpdated');
        }
        else
        {   
            toast.error(result.data.message);
        }
    }

    return(
        <>
            <div 
            className='login-page'
            style=
            {{
                backgroundSize: 'cover',
                backgroundImage: `url(${backgroundImage})`,
                backgroundRepeat: 'no-repeat',
            }}
            >
                <div className='login-box elevation-4'>
                    <div className='card-header text-center'>
                        <Link 
                        className='brand-link clearfix'
                        to={'/login'} 
                        >
                            <Image src={vizLogo} alt={'VizLink App Logo'}/>
                        </Link>
                    </div>


                    {
                        currentScreen == 'resetPassword' &&
                        <div>
                            <div className='card-body'>
                                <p className='login-box-msg text-bold'>
                                    {'Reset your Password'}
                                </p>
                            </div>

                            <Formik
                                enableReinitialize
                                validationSchema={resetPasswordValidationSchema}
                                onSubmit={() => resetPasswordSubmit()}
                                initialValues={resetPasswordObject}
                                >
                                {
                                    (formik) =>
                                    (
                                        <Form autoComplete={'off'}>
                                            <Modal.Body>
                                                <Container>
                                                    <Row>
                                                        <Col xs={12} md={12}>
                                                            <div className='form-group'>
                                                            <FormikControl
                                                                formik={formik}
                                                                control='input'
                                                                type='text'
                                                                label='Email'
                                                                name='email'
                                                                value={resetPasswordObject.email}
                                                                readOnly={true}
                                                                handleOnChange={text => setResetPasswordObject({ ...resetPasswordObject, email: text})}
                                                            />
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={12}>
                                                            <div className='form-group'>
                                                            <FormikControl
                                                                formik={formik}
                                                                control='input'
                                                                type='password'
                                                                label='New Password'
                                                                name='newPassword'
                                                                value={resetPasswordObject.newPassword}
                                                                handleOnChange={text => setResetPasswordObject({ ...resetPasswordObject, newPassword: text})}
                                                            />
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={12}>
                                                            <div className='form-group'>
                                                            <FormikControl
                                                                formik={formik}
                                                                control='input'
                                                                type='password'
                                                                label='Confirm New Password'
                                                                name='confirmPassword'
                                                                value={resetPasswordObject.confirmPassword}
                                                                handleOnChange={text => setResetPasswordObject({ ...resetPasswordObject, confirmPassword: text})}
                                                            />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                
                                                    <Row className='mt-3 mb-5'>
                                                        <input
                                                            className='btn btn-block btn-primary'
                                                            type='submit'
                                                            value='Update Password'
                                                        />
                                                    </Row>
                                                </Container>
                                            </Modal.Body>
                                        </Form>
                                    )
                                }
                            </Formik>
                        </div>
                    }

                    {
                        currentScreen == 'invalidUpdateRequest' &&
                        <div>
                            <div className='card-body'>
                                <p className='login-box-msg text-bold'>
                                    {'Unauthorized or malformed password change attempt'}
                                </p>
                                <p className='login-box-msg mt-5 mb-4'>
                                    {'The password update failed due to an unauthorized request, invalid token, or expired update time. Please request a new password reset link to proceed.'}
                                </p>
                                <Link className='btn btn-block btn-primary mb-5'
                                    to={'/login'} >
                                    Click here to navigate login page
                                </Link>
                            </div>
                        </div>
                    }

                    {
                        currentScreen == 'passwordUpdated' &&
                        <div>
                            <div className='card-body'>
                                <p className='login-box-msg text-bold'>
                                    {'Password Updated successfully.'}
                                </p>
                                <p className='login-box-msg mt-5 mb-4'>
                                    {'Please login to your account'}
                                </p>
                                <Link className='btn btn-block btn-primary mb-5'
                                    to={'/login'} >
                                    Login
                                </Link>
                            </div>
                        </div>
                    }
                </div>

            </div>
                
        </>
        
    )
}

const mapStateToProps = (state) => 
{
  return{
  }
}

export default connect(mapStateToProps, { VerifyUserForUpdatePassword , UpdateUserPasswordThroughEmail} )(ResetPasswordThroughEmail);